module.exports = __webpack_public_path__ + "static/send-9a7aa10dc4b765fb4f0d1933c0046ea6.svg";